import { useSelector } from 'react-redux'
import { useFirestoreConnect } from 'react-redux-firebase'

import useAuth from '@webstollen/react-native/lib/hooks/useAuth'
import { Favorite } from '../../types/Favorites'

// type UserMap = {
//   [key: string]: {
//     list: Array<Favorite>
//   }
// }

const useFavorites = (): Record<string, Favorite> => {
  const auth = useAuth()

  useFirestoreConnect(() => [
    {
      collection: `user/${auth.uid}/favorites`,
      //doc: auth.uid,
      storeAs: 'user_favorites',
    },
  ])

  const favorites =
    useSelector(
      (state: { firestore: { data: { user_favorites?: Record<string, Favorite> } } }) =>
        state.firestore.data?.user_favorites
    ) || ({} as Record<string, Favorite>)
  return favorites
}

export default useFavorites
